import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import cx from 'classnames';
import { DatePicker } from '../../DatePicker';
import cn from './SliderValueGrip.css.json';
import './SliderValueGrip.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SliderDatePicker = /*#__PURE__*/forwardRef(function SliderDatePicker(props, ref) {
  const [isFocused, setIsFocused] = useState(false);
  const refDatePicker = useRef(null);
  useImperativeHandle(ref, () => ({
    focusInput() {
      refDatePicker.current?.focus();
    }
  }));
  const {
    setSliderGripControlIsVisible
  } = props;
  useEffect(() => {
    if (isFocused) {
      setSliderGripControlIsVisible?.(true);
    } else {
      setSliderGripControlIsVisible?.(false);
    }
  }, [isFocused, setSliderGripControlIsVisible]);
  return /*#__PURE__*/_jsx(DatePicker
  // FIXME: TS 3.7.5 can't spread unions, works in 4.0 (and maybe 3.9)
  , {
    ...props.datePickerProps,
    testId: props.testId,
    enableResetButton: false,
    ariaLabel: props.ariaLabel,
    ref: refDatePicker,
    className: cx(cn.datepicker, props.datePickerProps.className, !isFocused && cn.offscreen),
    style: props.datePickerProps.style,
    value: new Date(props.value),
    onChange: e => {
      props.onCommit({
        value: e.value?.getTime() ?? new Date().getTime()
      });
    },
    onCancel: props.onCancel,
    onFocusIn: () => setIsFocused(true),
    onFocusOut: isValid => setIsFocused(isValid === false ? true : false),
    preventScroll: props.datePickerProps.preventScroll
  });
});
//# sourceMappingURL=SliderDatePicker.js.map